interface SeccionProximamenteProps {
  titulo: string;
  descripcion: string;
}

/**
 * Placeholder para una parte del design system que todavía no existe.
 *
 * A propósito NO lleva spinner ni texto de "cargando": un spinner promete
 * que algo va a aparecer si esperás, y acá no hay ninguna consulta corriendo
 * del otro lado — es una sección que no se construyó todavía. El borde
 * punteado y el título en gris son la señal de "esto es un hueco a
 * propósito", no un error ni un dato vacío.
 */
export const SeccionProximamente = ({ titulo, descripcion }: SeccionProximamenteProps) => (
  <div className="rounded-2xl border border-dashed border-[#D8DCE6] bg-transparent py-10 px-6 text-center">
    <p className="text-[13px] font-semibold text-[#02062B]/[0.45]">{titulo}</p>
    <p className="mx-auto mt-2 max-w-md text-[13px] leading-relaxed text-[#02062B]/[0.55]">
      {descripcion}
    </p>
  </div>
);

export default SeccionProximamente;
